import React, { useRef } from 'react';
import ReactTooltip from '@huner2/react-tooltip';

export function WithTooltip({ children, text, open }) {
  const containerRef = useRef(null);

  const handleClick = () => {
    if (window.innerWidth <= 768) {
      ReactTooltip.show(containerRef.current);
      setTimeout(() => {
        ReactTooltip.hide(containerRef.current);
      }, 5000);
    }
  };

  return (
    <div
      ref={containerRef}
      onClick={handleClick}
      data-tip={text}
      data-tip-disable={open}
      data-html={true}
    >
      {children}
    </div>
  );
}
